import { AUTH_ROUTE_CONST } from '@sapporo/core/constant';
import type { DelegationSession } from '../../store';
import { isDelegationReferrerAllowed, parseDelegationSearch } from './util';

/**
 * 라우터와 Sentry 가 주소를 읽기 전에 호출해야 합니다.
 * 엔트리에 정적으로 들어가므로 store 런타임을 import 하지 않습니다.
 */
export const takeDelegationSessionFromUrl = (): Nullish<DelegationSession> => {
  const isDelegationEntry =
    isDelegationReferrerAllowed(
      document.referrer,
      import.meta.env.VITE_APP_ADMIN_URL,
      import.meta.env.DEV,
    ) && !location.pathname.startsWith(AUTH_ROUTE_CONST.AUTH_ROUTE_PATH);
  const delegationSession = isDelegationEntry
    ? parseDelegationSearch(location.search)
    : null;

  if (isDelegationEntry) {
    const nextURL = new URL(location.href);

    nextURL.searchParams.delete('delegationOTP');
    nextURL.searchParams.delete('tenant');
    history.replaceState(
      history.state,
      '',
      `${nextURL.pathname}${nextURL.search}${nextURL.hash}`,
    );
  }

  return delegationSession;
};
